namespace nsc {
    export type GoogleAnalyticsEvent =
        | "m_broker_quick_login"
        | "m_broker_signup"
        | "m_busnotevalue_submit"
        | "m_exit_intent_submit"
        | "m_investor_criteria_submit"
        | "m_investor_preferences_submit"
        | "m_investor_profile_submit"
        | "m_notevalue_submit"
        | "m_quote_screen1_submit"
        | "m_quote_screen2_submit"
        | "m_quote_screen3_submit"
        | "m_quote_thankyou_submit"
        | "m_sellyourhouse_submit";

    // This is a dictionary that maps event names to conversions to be recorded.
    const eventConversions: Partial<Record<GoogleAnalyticsEvent, string | string[]>> = {
        "m_exit_intent_submit":     "AW-1069736863/JNF2CIiFz5QBEJ_Hi_4D",
        "m_quote_screen1_submit":   "AW-1069736863/FVlPCPfMu5UBEJ_Hi_4D"
    };

    export function sendGoogleAnalyticsEvent(event: GoogleAnalyticsEvent, params?: any) {
        const conversionTracker = eventConversions[event];

        if (conversionTracker) {
            gtag("event", "conversion", { send_to: conversionTracker });
        }

        if (typeof params === "string") {
            params = { event_category: params };
        }

        gtag("event", event, {
            event_label: "Mobile site",
            send_to: "analytics",
            ...params
        });
    }
}